import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers/root";
import AmpDropdown, { Option } from "../../common/AmpDropdown/AmpDropdown";
import AmpInput from "../../common/AmpInput/AmpInput";
import { SearchConfigResponse } from "../../../redux/reducers/getNBHDReducer/getConfigReducer";
import { searchCityCoords } from "../../../redux/actions/nbhd/search";
import AmpFormError from "../../common/AmpFormError/AmpFormError";
import "./Search.css";
import { CommercialSearchPayload, CondoSearchPayload, getSearchConfig, Range, ResSearchPayload, RollSearchPayload, searchAutoComplete, searchFull, SearchPayload, UomRange } from "../../../redux/actions/nbhd/search";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { AutoCompleteItem, AutoCompleteResponse } from "../../../redux/reducers/getNBHDReducer/getAutoCompleteReducer";
import { arrayEquals } from "../../../utils/arrayEquals";
import SearchResults from "../SearchResults/SearchResults";
import { SearchResponse } from "../../../redux/reducers/getNBHDReducer/getSearchReducer";
import { CityResponse } from "../../../redux/reducers/getNBHDReducer/getCityReducer";
import extractFormData from "../../../utils/extractFormData";
import RollNumberInput from "../../common/AmpInput/RollNumberInput";
import { getRollFromInput } from "../../../utils/getRollFromRollInput";
import { AUTOCOMPLETE, NBH_SEARCH } from "../../../redux/actionTypes/actionsTypes";
import AmpInlineLoadingSpinner from "../../common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";
import { useTranslation } from "react-i18next";
import { useMap } from "react-map-gl";
import  * as drawCircle from '@turf/circle';
import AmpToolTip from "../../common/AmpToolTip/AmpToolTip";

type SearchTypes = "ADDR" | "COMM" | "CONDO" | "ROLL";

export interface SearchProp {
    subPropCoord: Array<number>;
    subPropMun: string;
    handleViewChange: (e) => void;
  }
  

export default function Search(props: SearchProp) {
    const { t, i18n } = useTranslation("nbhd");
    const config = useSelector((state: RootState) => state.NBHDReducer.Config as SearchConfigResponse);
    const autocomplete = useSelector((state: RootState) => state.NBHDReducer.AutoComplete as AutoCompleteResponse);
    const search = useSelector((state: RootState) => state.NBHDReducer.Search as SearchResponse);
    const CityCoords = useSelector((state: RootState) => state.NBHDReducer.CityCoords as CityResponse);
    const group = localStorage.getItem("propertyType");

    const [propertyDescDropdown, setPropDescDropdown] = useState<Array<Option>>([{ text: "Loading...", value: null }]);
    const [yearBuiltDropdown, setYearBuiltDropdown] = useState<Array<Option>>([{ text: "Loading...", value: null }]);
    const [buildingExtDd, setbuildingExtDd] = useState<Array<Option>>([{ text: "Loading...", value: null }]);
    const [commDd, setCommDd] = useState<Array<Option>>([{ text: "Loading...", value: null }]);

    const [autoCompleteResults, setAutoCompleteResults] = useState<Array<AutoCompleteItem>>([]);

    const [city, setCity] = useState("");

    const [cityCoords, setCityCoords] = useState({})
    
    const dispatch = useDispatch();

    const [resetting, setReset] = useState(false);

    const [radiusToggle, setRadiusToggle] = useState(false);

    const [propDescSelected, setPropDescSelected] = useState(false);

    const [enableSearchRadius, setEnableSearchRadius] = useState(false);

    const { mainMap } = useMap();

    const [sliderValue, setSliderValue] = React.useState(0);

    const [currentRange, setCurrentRange] = React.useState(0);

    const coords = props.subPropCoord;

    const subPropMun = props.subPropMun;

    const sildeMarkers = [
        {
          value: 0,
          label: <img src="images/Pins/blue_marker.png" id="Blue-Pin" alt="Your property pin"/>,
        },
        {
          value: 10,
          label: '1KM',
        },
        {
          value: 20,
          label: '5KM',
        },
        {
          value: 30,
          label: '10KM',
        },
        {
          value: 40,
          label: '25KM',
        },
        {
          value: 50,
          label: '50KM',
        }
      ];

    useEffect(() => {
        if (resetting) {
            setTimeout(() => {
                setReset(false);
            }, 400);
            setTimeout(() => {
                (document.getElementById("search-button") as HTMLButtonElement).focus();
            }, 500);
        }
    }, [resetting])

    const getDefaultSearchType = (): SearchTypes => {
        const propertyCode = localStorage.getItem("propertyCode");
        if (["367", "368", "370", "376", "377", "378", "378", "379", "380"].includes(propertyCode as string)) {
            return "CONDO";
        } else if (group === "com"){
            return "COMM";
        } else {
            return "ADDR";
        }
    }

    const [searchType, setSearchType] = useState(getDefaultSearchType());

    const buildPropDowndown = (config: SearchConfigResponse) => {
        if (config.dropDownConfig?.prop_desc) {

            const dropdowns = config.dropDownConfig?.prop_desc.map((value, index): Option => {
                if (i18n.language === "en") {
                    return {
                        value: value.code as string,
                        text: value.title_en as string
                    }
                } else {
                    return {
                        value: value.code as string,
                        text: value.title_fr as string
                    }
                }
            });
            dropdowns.unshift({ value: null, text: "--" });
            setPropDescDropdown(dropdowns);
        }
    }

    const buildCommDropDown = (config: SearchConfigResponse) => {
        const values = config.comm_dropdown;
        if (values) {
            const dropdowns = values.map((value): Option => {
                return {
                    value: value.property_cd as string,
                    text: `${value.property_cd} - ${value.property_cd_desc}`
                }
            });
            dropdowns.unshift({ value: null, text: "--" });
            setCommDd(dropdowns);
        }
    }

    const buildYearBuiltDd = (config: SearchConfigResponse) => {

        if (config.dropDownConfig?.yearBuilt) {
            const ybConfig = config.dropDownConfig?.yearBuilt;

            const dd = [];
            let currentYear = ybConfig?.minYear;
            const step = ybConfig.stepSize;

            dd.push({ value: null, text: "--" });
            // Less than min year
            dd.push({
                value: `0-${ybConfig?.minYear}`,
                text: `< ${ybConfig?.minYear}`
            });
            while (currentYear < ybConfig?.maxYear) {
                dd.push({
                    value: `${currentYear}-${currentYear + step - 1}`,
                    text: `${currentYear}-${currentYear + step - 1}`
                });
                currentYear += step;
            }
            // Greater than max year
            dd.push({
                value: `${ybConfig?.maxYear}-0`,
                text: `>= ${ybConfig?.maxYear}`
            });

            setYearBuiltDropdown(dd);
        }
    }

    const buildBuildingExtDd = (config: SearchConfigResponse) => {
        if (config.dropDownConfig?.totalArea) {
            const areaConfig = config.dropDownConfig?.totalArea;

            const dd = [];
            let current = areaConfig?.minRange;

            const stepSmall = areaConfig.smallStep;
            const stepLarge = areaConfig.largeStep;
            const breakP = areaConfig.smallStepSizeBreakPoint;

            dd.push({ value: null, text: "--" });
            // Less than min year
            dd.push({
                value: `0-${current}`,
                text: `< ${current}`
            });
            while (current < areaConfig?.maxRange) {

                if (current >= breakP) {
                    dd.push({
                        value: `${current}-${current + stepLarge - 1}`,
                        text: `${current}-${current + stepLarge - 1}`
                    });

                    current += stepLarge;
                } else {
                    dd.push({
                        value: `${current}-${current + stepSmall - 1}`,
                        text: `${current}-${current + stepSmall - 1}`
                    });
                    current += stepSmall;
                }
            }
            // Greater than max year
            dd.push({
                value: `${areaConfig?.maxRange}-0`,
                text: `>= ${areaConfig?.maxRange}`
            });

            setbuildingExtDd(dd);
        }
    };

    useEffect(() => {
        if (config.dropDownConfig && !config.loading) {
            buildPropDowndown(config);
            buildYearBuiltDd(config);
            buildBuildingExtDd(config);
            buildCommDropDown(config);
        } else if (!config.loading && !config.dropDownConfig) {
            dispatch(getSearchConfig());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config, dispatch, i18n.language]);

    useEffect(() => {
        if (!autocomplete.loading && autocomplete.results) {
            if (!arrayEquals(autoCompleteResults, autocomplete.results)) {
                setAutoCompleteResults(autocomplete.results);
            }
        }
    }, [autocomplete, autoCompleteResults])

    const autoCompleteFunction = (e: React.ChangeEvent<Element>) => {
        dispatch(searchAutoComplete(e.target.value, searchType, city));
    };

    const extractRangeFromText = (value: string | null): Range => {
        if (value === "--" || value === null) {
            return {
                from: null,
                to: null
            }
        } else {
            const parts = value.split("-");
            return {
                from: (Number(parts[0]) > 0 ? Number(parts[0]) : null),
                to: (Number(parts[1]) > 0 ? Number(parts[1]) : null)
            }
        }
    }

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const data = extractFormData(e);
        // Address Res Search
        if (searchType === "ADDR") {
            if (radiusToggle && (data["pd"] === "--")) {
                setPropDescSelected(true);
            } else {
                setPropDescSelected(false);
                const payload: ResSearchPayload = {
                    search_addr: data["search_addr"] as string,
                    search_city: data["search_city"] ? data["search_city"] as string : null,
                    page: 1,
                    prop_desc: data["pd"] !== ("--" || null) ? data["pd"] as string : null,
                    year_built: extractRangeFromText(data["yb"] as string),
                    ext_sqft: extractRangeFromText(data["ext_sqft_res"] as string),
                    num_full_storey: data["full_storey"] !== ("--" || null) ? Number(data["full_storey"]) : null,
                    num_part_storey: data["part_storey"] !== ("--" || null) ? Number(data["part_storey"]) : null,
                    lot_size: {
                        uom: data["lot_size_uom"] as UomRange["uom"],
                        min: data["lot_size_min"] ? Number(data["lot_size_min"]) : null,
                        max: data["lot_size_max"] ? Number(data["lot_size_max"]) : null
                    },
                    frontage: {
                        uom: data["frontage_uom"] as UomRange["uom"],
                        min: data["frontage_min"] ? Number(data["frontage_min"]) : null,
                        max: data["frontage_max"] ? Number(data["frontage_max"]) : null
                    },
                    range: currentRange?currentRange:null,
                    lat: coords?coords[1]:null,
                    lon: coords?coords[0]:null
                }
                dispatch(searchFull(payload));
            }
        } else if (searchType === "CONDO") {
            const payload: CondoSearchPayload = {
                search_addr: data["search_addr"] as string,
                search_city: data["search_city"] ? data["search_city"] as string : null,
                page: 1,
                is_condo: true,
                unit_num: data["unit_num"] === "" ? null : data["unit_num"] as string,
                ext_sqft: extractRangeFromText(data["ext_sqft"] as string),
                num_bath: data["num_bath"] === "" ? null : Number(data["num_bath"]),
                num_bed: data["num_bed"] === "" ? null : Number(data["num_bed"]),
                range: currentRange?currentRange:null,
                lat: coords?coords[1]:null,
                lon: coords?coords[0]:null
            }
            dispatch(searchFull(payload));
        } else if (searchType === "COMM") {
            const payload: CommercialSearchPayload = {
                search_addr: data["search_addr"] as string,
                search_city: data["search_city"] ? data["search_city"] as string : null,
                page: 1,
                is_comm: true,
                code: data["comm_code"] !== ("--" || null) ? Number(data["comm_code"]) : null
            }
            dispatch(searchFull(payload));
        } else if (searchType === "ROLL") {
            const payload: RollSearchPayload = {
                page: 1,
                is_roll: true,
                roll: getRollFromInput(data)
            }
            dispatch(searchFull(payload));
        }
    };

    const searchChange = (value: SearchTypes) => {
        setSearchType(value);
    }

    const pager = (payload: SearchPayload) => {
        dispatch(searchFull(payload));
    }

    const refreshForm = (e) => {
        dispatch({ type: NBH_SEARCH.RESET })
        dispatch({ type: AUTOCOMPLETE.RESET })
        setSearchType(searchType);
        setCity("");
        setReset(true)
        setSliderValue(0);
        setCurrentRange(0);
        changeMapCircle([0,0], 0);
        setRadiusToggle(false);
        setPropDescSelected(false);
    }

    const toggleRadius = (e) => {
        let radius = 0;
        if (e.target.checked) {
            setRadiusToggle(true);
            setCurrentRange(1);
            setSliderValue(0);
            radius = 0.001;
        } else {
            setPropDescSelected(false);
            setRadiusToggle(false);
            setCurrentRange(0);
            setSliderValue(0);
            radius = 0;
        }
        changeMapCircle(coords, radius);
    }  

    const slideValToRange = (slideVal:number, setZoom: boolean) => {
        let selectedRange = 0;
        if (slideVal === 0) {
            setZoom && mainMap?.setZoom(20);
            selectedRange = 0.001;
        } else if (slideVal === 10) {
            setZoom && mainMap?.setZoom(14);
            selectedRange = 1;
        } else if (slideVal === 20) {
            setZoom && mainMap?.setZoom(12);
            selectedRange = 5;
        } else if (slideVal === 30) {
            setZoom && mainMap?.setZoom(11);
            selectedRange = 10;
        } else if (slideVal === 40) {
            setZoom && mainMap?.setZoom(9);
            selectedRange = 25;
        } else if (slideVal === 50) {
            setZoom && mainMap?.setZoom(8);
            selectedRange = 50;
        } else {
            selectedRange = 0;
        }
        return selectedRange;
    }

    const changeMapCircle = (coordxy:number[], r:number) => {
        if (mainMap) {
            const radius = r;
            const center = coordxy;
            const options = {
                    steps: Number(64),
                    units: String("kilometers"),
                  };
            const circle = drawCircle.default(center, radius, options);
            mainMap.getSource('CirlceData').setData(circle);
        }
    }
    const radiusChange = (e) => {
        setSliderValue(e.target.value);
        const selectedRange = slideValToRange(Number(e.target.value), true);
        setCurrentRange(selectedRange*1000);
        changeMapCircle(coords, selectedRange);
    }

    const generateSliderTicks = () => {
        const options = [];
        const labels = [];

        for (const value of sildeMarkers){
            const isSelected = slideValToRange(value.value, false) === currentRange/1000 ? "o_on" : "";
            options.push((
                <option key={`slider-option-${value.value}`}>{value.value}</option>  
            ))
            labels.push((
                <span key={`slider-label-${value.value}`} className={`o_txt ${isSelected}`}>{value.label}</span>
            ))
        }
        return <>
            <datalist id="steplist">
                {options}
            </datalist>
            <div className="ticks">
                {labels}
            </div>
        </>
    }

    useEffect(() => {
        if ((searchType === "ROLL" ) || (searchType === "COMM")) {
            setEnableSearchRadius(false);
            setRadiusToggle(false);
            changeMapCircle([0,0], 0);
        } else {
            setEnableSearchRadius(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[searchType, resetting]);

    useEffect(() => {
        if (search.results) {
            const missingCoords:Array<string> = [];
            search.results.forEach((address) => {
                if ((address.centroid.lat === null) || (address.centroid.lon === null)) {
                    //remove all pre-fix or take first of city name
                    if (address.city.includes('CITY OF')){
                        missingCoords.push(address.city.replace('CITY OF ',''));
                    } else if (address.city.includes('NORTH ')){
                        missingCoords.push(address.city);
                    } else if (address.city.includes('SOUTH ')){
                        missingCoords.push(address.city);
                    } else if (address.city.includes('st. ')){
                        missingCoords.push(address.city);
                    } else {
                        missingCoords.push(address.city.substring(0, address.city.indexOf(' ')));
                    }
                    
                }
            });
            if (missingCoords.length > 0) {
                dispatch(searchCityCoords({cities:[...new Set(missingCoords)]}))
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search]);

    useEffect(() =>{
        const cityCoordObject = {}
        if (Object.keys(CityCoords).length !== 0) {
            if("city_coords" in CityCoords){
                CityCoords["city_coords"].forEach((city) => {
                    cityCoordObject[city["city"].toUpperCase()] = [city["lat"], city["lng"]];
                });
                setCityCoords(cityCoordObject);
            }
        }
     // eslint-disable-next-line react-hooks/exhaustive-deps   
    }, [CityCoords]);

    return (
        <>
            {!resetting && 
            <>
                <form className="search-top" onSubmit={(e) => { onSubmit(e) }} onReset={((e) => { refreshForm(e) })}>
                    <div className="searchbar-top">
                        <AmpDropdown
                            onChange={(e) => { searchChange((e.target as HTMLSelectElement).value as SearchTypes) }}
                            className="dropdown"
                            value={searchType}
                            ariaLabel="Search Type"
                            options={[
                                {
                                    value: "ADDR",
                                    text: t("nbhd.search.address"),
                                },
                                (group === "res" ?
                                    {
                                        value: "CONDO",
                                        text: t("nbhd.search.condo"),
                                    } :
                                    null
                                ),
                                (group !== "res" ?
                                    {
                                        value: "COMM",
                                        text: t("nbhd.search.commercial"),
                                    } :
                                    null
                                ),
                                {
                                    value: "ROLL",
                                    text: t("nbhd.search.roll"),
                                },
                            ]} />
                        <div className="input-search">
                            <AmpInput
                                id="nbh-search"
                                name="search_addr"
                                className="searchbar"
                                placeholder={t("nbhd.search.ph-addr")}
                                type="text"
                                onChange={(e) => { autoCompleteFunction(e) }}
                                loading={autocomplete.loading}
                                autoComplete="off"
                                autoCompleteAPIEnabled={true}
                                autoCompleteAPIItems={autoCompleteResults}
                                disabled={searchType === "ROLL"}
                            />
                            <button className="search-icon" type="submit" id="search-button" aria-label="Search property">
                                <FontAwesomeIcon className="search-font-awesome-icon" icon={faMagnifyingGlass} />
                            </button>
                            <button className="search-icon" type="reset" aria-label="Refresh search">
                                <FontAwesomeIcon className="search-font-awesome-icon" icon={faRefresh} />
                            </button>
                        </div>
                    </div>

                        <div className="searchbar-second">
                                <div className="searchbar">
                                <AmpInput
                                    id="nbh-search-city"
                                    name="search_city"
                                    className="searchbar search-city"
                                    placeholder={t("nbhd.search.ph-muni")}
                                    type="text"
                                    autoComplete="off"
                                    autoCompleteAPIEnabled={false}
                                    onInput={e => setCity(e)}
                                    value={city?city:subPropMun}
                                    disabled={searchType === "ROLL"}
                                />
                                    <span className="search-bar-tool-tip"><AmpToolTip id={"SliderToolTip"} content={t("nbhd.search.city-search-tool-tip") as string} direction="left"/></span>
                                </div>
                                
                              
                        </div>
                        
                    
                    <div className={enableSearchRadius ? "radiusbar-top" : "radiusbar-top-hidden"} id="radiusbar-top">
                        <div className = {radiusToggle ? "rangeContainer-extand"  : "rangeContainer" } id ="rangeContainer">
                            <div className="switch-label-left">
                                <span>{t("nbhd.search.radius-toggle")}</span>
                            </div>
                            
                            <div>
                                <label className="switch">
                                    <input id="toggleSlider" type="checkbox" onChange={(e) =>  {toggleRadius(e)}} disabled={!enableSearchRadius} checked={radiusToggle}/>
                                    <span className="slider-switch"></span>
                                </label>
                            </div>

                            {radiusToggle &&
                            // <span className="slider-container">
                            //     
                            //     <input className="radius-slider" type="range" id="myRange" step="25" min="0" max="100" list="steplist"/>

                            //     </datalist>
                            //     <span>50KM</span>
                            // </span> 

                            <div className="options">
                                <input className="slider" type="range" value={sliderValue} min="0" max="50" step="10" list="steplist" onChange={(e) => radiusChange(e)}/>
                                {generateSliderTicks()}
                            </div>
                                
                            }
                        </div>
                    </div>
                    <div className={(searchType !== "ADDR" && "invisible") || "refine-wrapper"}>
                        <div className="search-refine">
                            {propDescSelected && <div className="search-warning">
                                <AmpFormError error={propDescSelected} errorMessage={t("nbhd.search.search-warning")} />
                            </div>}
                            <label className="refine-heading" htmlFor={t("nbhd.search.prop-desc")}>{t("nbhd.search.prop-desc")}
                            {radiusToggle && <div className="required-field">&nbsp;*</div>}</label>
                            <div className="refine-right-dropdown">
                                <div className= {propDescSelected?"pdDropdown" : ""}> 
                                    <AmpDropdown options={propertyDescDropdown} name="pd" id={t("nbhd.search.prop-desc")} />
                                </div>
                                
                            </div>

                            <label className="refine-heading" htmlFor={t("nbhd.search.year-built")}>{t("nbhd.search.year-built")}</label>
                            <div className="refine-right-dropdown">
                                <AmpDropdown options={yearBuiltDropdown} name="yb" id={t("nbhd.search.year-built")}/>
                            </div>

                            <label className="refine-heading border-bottom" htmlFor={t("nbhd.search.sq-footage")}>{t("nbhd.search.sq-footage")}</label>
                            <div className="refine-right-dropdown">
                                <AmpDropdown options={buildingExtDd} name="ext_sqft_res" id={t("nbhd.search.sq-footage")}/>
                            </div>
                        </div>

                        <div className="search-refine">
                            <div className="refine-heading refine-heading-small col-1-head">{t("nbhd.search.num-storey")}</div>
                            <label className="refine-heading refine-heading-mid" htmlFor={t("nbhd.search.full-storey")}>{t("nbhd.search.full-storey")}</label>
                            <div className="refine-right-dropdown">
                                <AmpDropdown options={[
                                    { value: null, text: "--" },
                                    { value: "1", text: "1" },
                                    { value: "2", text: "2" },
                                    { value: "3", text: ">2" }
                                ]} name="full_storey" id={t("nbhd.search.full-storey")}/>
                            </div>
                            <label className="refine-heading refine-heading-mid" htmlFor={t("nbhd.search.part-storey")}>{t("nbhd.search.part-storey")}</label>
                            <div className="refine-right-dropdown">
                                <AmpDropdown options={[
                                    { value: null, text: "--" },
                                    { value: "1", text: "1/4 Storey" },
                                    { value: "2", text: "1/2 Storey" },
                                    { value: "3", text: "3/4 Storey" }
                                ]} name="part_storey" id={t("nbhd.search.part-storey")}/>
                            </div>

                        </div>

                        <div className="search-refine">
                            <label className="refine-heading refine-heading-small col-1-head" htmlFor={t("nbhd.search.lot-size")}>{t("nbhd.search.lot-size")}</label>
                            <div className="refine-right-dropdown refine-heading-mid col-1-head">
                                <AmpDropdown options={[
                                    { value: "F", text: "Sq. Ft." },
                                    { value: "A", text: "Acre" }
                                ]} name="lot_size_uom" id={t("nbhd.search.lot-size")} />
                            </div>
                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="lot-size-min"
                                    name="lot_size_min"
                                    className="range-search"
                                    placeholder="Min"
                                    type="text"
                                />
                            </div>

                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="lot-size-max"
                                    name="lot_size_max"
                                    className="range-search"
                                    placeholder="Max"
                                    type="text"
                                />
                            </div>
                        </div>
                        <div className="search-refine">
                            <label className="refine-heading refine-heading-small col-1-head" htmlFor={t("nbhd.search.frontage")}>
                                {t("nbhd.search.frontage")}
                            </label>
                            <div className="refine-right-dropdown refine-heading-mid col-1-head">
                                <AmpDropdown options={[
                                    { value: "F", text: "Feet" },
                                    { value: "M", text: "Metres" }
                                ]} name="frontage_uom" id={t("nbhd.search.frontage")}/>
                            </div>
                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="frontage-min"
                                    name="frontage_min"
                                    className="range-search"
                                    placeholder="Min"
                                    type="text"
                                />
                            </div>

                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="frontage-max"
                                    name="frontage_max"
                                    className="range-search"
                                    placeholder="Max"
                                    type="text"
                                />
                            </div>
                        </div>
                    </div>

                    <div className={(searchType !== "CONDO" && "invisible") || "refine-wrapper"}>
                        <div className="search-refine">
                            <div className="refine-heading">{t("nbhd.search.unit-num")}</div>
                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="unit_num"
                                    name="unit_num"
                                    className="range-search"
                                    placeholder="#"
                                    type="text" />
                            </div>

                            <div className="refine-heading border-bottom">{t("nbhd.search.sqft")}</div>
                            <div className="refine-right-dropdown">
                                <AmpDropdown options={[
                                    { value: "--", text: "--" },
                                    { value: "0-500", text: "< 500" },
                                    { value: "500-1000", text: "500-1000" },
                                    { value: "1000-0", text: "> 1000" }
                                ]} name="ext_sqft" />
                            </div>
                            <div className="refine-heading">{t("nbhd.search.num-bed")}</div>
                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="num_bed"
                                    name="num_bed"
                                    className="range-search"
                                    placeholder="#"
                                    type="text" />
                            </div>
                            <div className="refine-heading">{t("nbhd.search.num-bath")}</div>
                            <div className="refine-right-dropdown">
                                <AmpInput
                                    id="num_bath"
                                    name="num_bath"
                                    className="range-search"
                                    placeholder="#"
                                    type="text" />
                            </div>
                        </div>
                    </div>

                    <div className={(searchType !== "COMM" && "invisible") || "refine-wrapper"}>
                        <label className="refine-heading refine-heading-small col-1-head" htmlFor={t("nbhd.search.prop-code")}>{t("nbhd.search.prop-code")}</label>
                        <div className="refine-right-dropdown col-1-head">
                            <AmpDropdown options={commDd} name="comm_code" id={t("nbhd.search.prop-code")} />
                        </div>
                    </div>
                    <div className={(searchType !== "ROLL" && "invisible") || "refine-wrapper"}>
                        <div className="refine-right-dropdown col-1-head">
                            <RollNumberInput noPlaceHolder={true} />
                        </div>
                    </div>
                </form>
                {propDescSelected && <div className="search-warning">{t("nbhd.search.search-warning")}</div>}
                <SearchResults response={search} loading={search.loading} resultsPayload={search?.data as SearchPayload} pagerCallback={pager} handleViewChange={props.handleViewChange} cityCoords={cityCoords}/>
            </>
        }
        {resetting &&
        <div className="refreshing">
            <AmpInlineLoadingSpinner/>
        </div>
        }
        </>


    )
}
